import NavigationHeader from 'components/molecules/navigation-header';
import LinkCallReadingsFilters from 'components/templates/link-call-readings-tool/filter';
import LinkCallReadingsTable from 'components/templates/link-call-readings-tool/table';
import { useTranslation } from 'react-i18next';

const LinkCallReadingsTool = () => {
  const { t } = useTranslation();

  return (
    <>
      <NavigationHeader title={t('links.linkCallReadingTool')} />
      <LinkCallReadingsFilters />
      <LinkCallReadingsTable />
    </>
  );
};
export default LinkCallReadingsTool;
